export default "__VITE_ASSET__BoUdWmrw__"